<mat-form-field>
  <mat-label>{{ label }}</mat-label>
  <input
    matInput
    class="region-select-input"
    readonly
    [formControl]="regions"
    [placeholder]="placeholder"
  />
  <span
    (click)="_openRegionSelectDialog($event)"
    (keydown.enter)="_openRegionSelectDialog($event)"
    class="display-input"
    tabindex="0"
    [class.placeholder]="!getDisplayValue()"
    >{{ getDisplayValue() || placeholder }}</span
  >
  <div class="icons">
    <button
      [disabled]="disabled"
      matSuffix
      mat-icon-button
      (click)="_openRegionSelectDialog($event)"
    >
      <mat-icon class="select-icon">travel_explore</mat-icon>
    </button>
  </div>
  @if (regions.hasError("required")) {
    <mat-error>{{ requiredErrorMessage() }}</mat-error>
  }
</mat-form-field>
